/* Wanderth — Add to Cart AJAX handler for product grid cards.
   Estrategia:
   1. POST /cart/add.js (FormData → menos fricción con anti-bot).
   2. Refresh manual del DOM del drawer fetching /cart?view=ajax. No
      dependemos sólo del evento ajaxProduct:added porque algunos setups
      del theme no reaccionan a él.
   3. Dispatcheo de múltiples eventos por compatibilidad con widgets.
   4. Click programático en el cart-link como último recurso para abrir
      el drawer si los listeners de cart:open fallan. */
(function () {
  'use strict';

  var SUCCESS_DURATION_MS = 1600;

  function log(/* ...args */) {
    if (window.console && console.log) {
      console.log.apply(console, ['[wanderth-atc]'].concat([].slice.call(arguments)));
    }
  }

  function setButtonState(button, state) {
    button.classList.remove('is-loading', 'is-success', 'is-error');
    if (state) button.classList.add(state);
  }

  function updateCartBubble(itemCount) {
    // Burbuja visible/oculta
    document.querySelectorAll('.cart-link__bubble').forEach(function (bubble) {
      bubble.classList.toggle('cart-link__bubble--visible', itemCount > 0);
    });

    // Número dentro de la burbuja — el tema usa .cart-link__bubble-num
    document.querySelectorAll('.cart-link__bubble-num, [data-cart-count], .cart-count').forEach(function (node) {
      node.textContent = String(itemCount);
      node.innerText  = String(itemCount);
    });

    // Animación pulse en el icono del carrito
    document.querySelectorAll('.cart-link').forEach(function (link) {
      link.classList.remove('is-pulsing');
      void link.offsetWidth;
      link.classList.add('is-pulsing');
      setTimeout(function () { link.classList.remove('is-pulsing'); }, 600);
    });
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    var amount = (cents / 100).toLocaleString('es-CO', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
    return '$' + amount;
  }

  /* Refresh manual del contenido del cart drawer.
     cart.ajax.liquid devuelve <div class="cart__items"> + <div class="cart__discounts">.
     El drawer tiene placeholders <div data-products>, <div data-discounts>,
     <div data-subtotal>. Reemplazamos sus contenidos. */
  function refreshCartDrawer() {
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer) {
      log('No #CartDrawer en el DOM — skip refresh');
      return Promise.resolve();
    }

    var url = '/cart?view=ajax&t=' + Date.now();

    return fetch(url, {
      credentials: 'same-origin',
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Items
        var newCartItems = doc.querySelector('.cart__items');
        var currentProducts = drawer.querySelector('[data-products]');
        if (newCartItems && currentProducts) {
          currentProducts.innerHTML = '';
          currentProducts.appendChild(newCartItems);
        }

        // Subtotal
        var subtotalCents = newCartItems
          ? parseInt(newCartItems.getAttribute('data-cart-subtotal'), 10)
          : 0;
        var currentSubtotal = drawer.querySelector('[data-subtotal]');
        if (currentSubtotal && !isNaN(subtotalCents)) {
          currentSubtotal.innerHTML = formatMoney(subtotalCents);
        }

        // Descuentos
        var newDiscounts = doc.querySelector('.cart__discounts');
        var currentDiscounts = drawer.querySelector('[data-discounts]');
        if (currentDiscounts) {
          currentDiscounts.innerHTML = '';
          if (newDiscounts && !newDiscounts.classList.contains('hide')) {
            currentDiscounts.appendChild(newDiscounts);
          }
        }

        // Empty state
        var count = newCartItems
          ? (parseInt(newCartItems.getAttribute('data-count'), 10) || 0)
          : 0;
        drawer.querySelectorAll('.drawer__inner, .drawer__contents, .cart').forEach(function (w) {
          if (count > 0) w.classList.remove('is-empty');
          else w.classList.add('is-empty');
        });

        // Forzar visibilidad de los <image-element> recién inyectados
        // (AOS no observa elementos añadidos dinámicamente).
        if (currentProducts) {
          currentProducts.querySelectorAll('[data-aos]').forEach(function (el) {
            el.classList.add('aos-animate');
          });
        }
        if (window.AOS && typeof AOS.refreshHard === 'function') {
          try { AOS.refreshHard(); } catch (e) { /* noop */ }
        }

        log('Drawer refreshed, items:', count, 'subtotal:', subtotalCents);
      })
      .catch(function (err) {
        console.error('[wanderth-atc] refreshCartDrawer failed:', err);
      });
  }

  /* Abrir el drawer. Estrategia en cascada:
     1. dispatchEvent cart:open (el theme.CartDrawer lo escucha)
     2. click programático en el cart-link si el evento no funcionó */
  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));

    // Si después de 200ms el drawer no se abrió, forzar click
    setTimeout(function () {
      var drawer = document.querySelector('#CartDrawer');
      var isOpen = drawer && (
        drawer.classList.contains('js-drawer-open') ||
        drawer.classList.contains('is-open') ||
        drawer.classList.contains('drawer--is-open')
      );
      if (!isOpen) {
        var cartLink = document.querySelector('.js-drawer-open-cart, [href$="/cart"]');
        if (cartLink) {
          log('Fallback: click programático en cart-link');
          cartLink.click();
        }
      }
    }, 200);
  }

  function notifyTheme(addedItem, button) {
    var detail = { product: addedItem || {}, addToCartBtn: button };
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: detail, bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail, bubbles: true }));
  }

  function addToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    setButtonState(button, 'is-loading');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (res) {
        log('POST /cart/add.js status:', res.status);
        if (!res.ok) {
          return res.text().then(function (text) {
            throw new Error('Add failed (' + res.status + '): ' + text.slice(0, 200));
          });
        }
        return res.text().then(function (text) {
          try { return JSON.parse(text); } catch (e) { return null; }
        });
      })
      .then(function (addedItem) {
        log('product added:', addedItem ? (addedItem.title || addedItem.id) : '(no payload)');

        return fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            // Actualizar contador del header sin abrir el drawer.
            updateCartBubble(cart.item_count);

            // cart:build actualiza el contenido interno del drawer
            // sin disparar this.open() (a diferencia de ajaxProduct:added).
            document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));

            // Refrescar contenido del drawer en background.
            return refreshCartDrawer();
          });
      })
      .then(function () {
        setButtonState(button, 'is-success');
        setTimeout(function () { setButtonState(button, ''); }, SUCCESS_DURATION_MS);
      })
      .catch(function (err) {
        console.error('[wanderth-atc] Error:', err);
        setButtonState(button, '');
      });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest
      ? e.target.closest('.wanderth-add-to-cart[data-variant-id]')
      : null;
    if (!button) return;
    if (button.disabled || button.classList.contains('is-loading')) return;

    e.preventDefault();
    addToCart(button);
  });
})();
